import React from 'react';
import ProjectCard from './ProjectCard';
import { featuredProjects } from '../../data/projects';
import './Projects.scss';

const Projects = () => (
  <section className="projects-section" id="projects">
    <div className="container">
      <div className="section-header">
        <span className="badge-label">Case Studies</span>
        <h2>Projects That Speak for Themselves</h2>
        <div className="section-divider" />
        <p>
          Representative material handling solutions across industries —
          built for safety, efficiency, and long-term reliability.
        </p>
      </div>

      <div className="row g-4">
        {featuredProjects.map((project) => (
          <div key={project.id} className="col-md-6 col-xl-3">
            <ProjectCard {...project} />
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <a
          href="/#contact"
          className="btn btn-outline-light rounded-pill px-4 py-2"
          style={{ fontWeight: 600 }}
        >
          Discuss Your Project →
        </a>
      </div>
    </div>
  </section>
);

export default Projects;
